<template>
  <v-app>
    <div id="main">
      <div id="sidebar" v-if="!isLoginPage">
        <router-link to="/">
          <img src="@/assets/nabla_favicon.svg"/>
        </router-link>
         <p id="beta" v-if="showBeta">BETA</p>
      </div>
      <div id="container">
        <Navbar v-if="!isLoginPage" /> 
        <router-view  />
      </div>
    </div>
  </v-app>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import { mapState } from 'vuex'

export default {
  name: 'App',
  components: {
    Navbar: defineAsyncComponent(() => import(/* webpackChunkName: "Navbar" */ '../src/modules/shared/components/MainNavBar')),
  },
  computed: {
    ...mapState(['windfarms']),
    isLoginPage() {
      return this.$route.path === '/login'
    },
       showBeta() {
      //const enel = ['CCNGL','SFLORO','PGALLA','SCAM']
      return false; // Temporarily disable beta tag
      //return enel.includes(this.windfarms[0])
    }
  }
}
</script>

<style>
#app {
  font-family: Poppins, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f5f5f5;

}
#main {
  display: flex;
}

#container {
  flex-grow: 1;
}
body {
  margin: 0;
}
div#main {
  display: flex;
  justify-content: space-between;
 
}
div#sidebar {
  width: 5.06vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0px 32.2999px 25.8399px rgba(0, 0, 0, 0.0417275), 0px 18.1071px 14.4856px rgba(0, 0, 0, 0.035), 0px 9.61652px 7.69322px rgba(0, 0, 0, 0.0282725), 0px 4.00165px 3.20132px rgba(0, 0, 0, 0.0196802);
  border-radius: 14.4607px;
  text-align: center;
}

div#sidebar img {
  position: relative;
  width: 60%;
  top: 30px;
}
#beta {
  font-size: 0.7rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: #5d5f72;
  background-color: #f0f1f8;
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid #d1d2e0;
  margin-top: 30px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}
div#sidebar router-link {
  display: block;
}

div#container {
  width: 91vw;
  background: #FFFFFF;
}

</style>

